import { inject, Injectable , ErrorHandler} from '@angular/core';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights, Exception } from '@microsoft/applicationinsights-web';
import { EnvironmentService } from '../environment/environment.service';
 
@Injectable({
  providedIn: 'root', // Ensure this is present
})

export class AppInsightsService {
  private envService = inject(EnvironmentService);
  private readonly router = inject(Router);
  private angularPlugin = new AngularPlugin();
  private appInsights = new ApplicationInsights({
    config: {
            //instrumentationKey: this.envService.getEnvironment().appInsightsKey,
      connectionString: this.envService.getEnvironment().connectionString,
      extensions: [this.angularPlugin],
      extensionConfig: {
        [this.angularPlugin.identifier]: {
          router: this.router,
          errorServices: [new ErrorHandler()],
        },
      },
    },
  });
  

  constructor() {
    this.appInsights.loadAppInsights();

    const onBoardApplication = `BIS.APP.${this.envService.getEnvironment().appType.toUpperCase()}`;
    const onBoardVersion = this.envService.getEnvironment().onBoardVersion;

    this.appInsights.addTelemetryInitializer(envelope => {
      envelope.tags['ai.cloud.role'] = onBoardApplication;
      envelope.tags['ai.application.ver'] = onBoardVersion;
    });
  }
 
  trackEvent(name: string): void {
    this.appInsights.trackEvent({ name });
  }
 
  trackTrace(message: string): void {
    this.appInsights.trackTrace({ message });
  }

  trackException(exception: Exception):void 
  {
    this.appInsights.trackException(exception)
  }
}